import React from 'react';

const labsData = [
  {
    id: 1,
    image: '/lab-foundation.jpg',
    name: 'Nursing Foundation Laboratory',
    desc: 'Equipped with mannequins, hospital beds, nursing trolleys, and all basic clinical equipment for foundational skill development in patient care, vital monitoring, and wound management.',
  },
  {
    id: 2,
    image: '/lab-advanced.jpg',
    name: 'Advanced Skill & Simulation Laboratory',
    desc: 'High-fidelity simulation manikins, IV trainers, CPR models, and cutting-edge simulation technology enabling students to practice advanced clinical procedures in a safe environment.',
  },
  {
    id: 3,
    image: '/lab-maternal.jpg',
    name: 'Maternal & Child Health (OBG & Pediatric) Laboratory',
    desc: 'Specialized laboratory for obstetrics, gynaecology, and pediatric nursing skills including birthing simulators, neonatal care models, and antenatal assessment equipment.',
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1579154204601-01588f351e67?w=600&q=80',
    name: 'Pre-Clinical Science Laboratory',
    desc: 'Fully equipped with microscopes, specimens, anatomical models, and biological samples to support learning of anatomy, physiology, biochemistry, and microbiology.',
  },
  {
    id: 5,
    image: 'https://images.unsplash.com/photo-1584515933487-779824d29309?w=600&q=80',
    name: 'Community Health Nursing Laboratory',
    desc: 'Designed to prepare students for community fieldwork with health survey tools, public health kits, nutrition assessment equipment, and community care simulation setups.',
  },
  {
    id: 6,
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=600&q=80',
    name: 'Nutrition Laboratory',
    desc: 'Dedicated space for nutritional assessment, diet planning, and food science experiments. Equipped with weighing scales, nutritional charts, cooking equipment, and dietary models.',
  },
];

function Labs() {
  return (
    <section id="labs" className="labs-section">
      <div className="section-container">
        <div className="section-title-block">
          <h2 className="section-title">
            <span className="title-icon">🔬</span> Our Laboratories
          </h2>
          <div className="gold-underline"></div>
          <p className="section-subtitle">
            State-of-the-Art Facilities Designed for Hands-On Clinical Excellence
          </p>
        </div>

        <div className="labs-grid">
          {labsData.map((lab) => (
            <div key={lab.id} className="lab-card">
              <div className="lab-image-wrap">
                <img src={lab.image} alt={lab.name} className="lab-image" />
              </div>
              <div className="lab-content">
                <h3 className="lab-name">{lab.name}</h3>
                <p className="lab-desc">{lab.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Labs;
